import React, { useState, useEffect} from 'react';
import { getBrandsByCompany } from '../../services/companyAuthService';
import { useDispatch } from 'react-redux';
import { setGeneralData } from '../../../Redux/campaignSlice';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import BrandDropdown from "../brand_sections/BrandDropdown";




const General = ({ onNext, data }) => {
  const dispatch = useDispatch();
  const [brands, setBrands] = useState([]);
  // const [selectedBrand, setSelectedBrand] = useState('');
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState(data || {
    name: '',
    description: '',
    brandId: '',
    brandName: '',
    campaignType: '',
    startDate: '',
    endDate: ''
  });
  const today = new Date();
  const sixMonthsLater = new Date();
  sixMonthsLater.setMonth(today.getMonth() + 6);

  // Fetch brands when component mounts
  useEffect(() => {
    const fetchBrands = async () => {
      try {
        setLoading(true);
        const response = await getBrandsByCompany();
        if (response.success) {
          // Only get active brands
          const activeBrands = response.brands.filter(brand => brand.isActive);
          setBrands(activeBrands);
        }
      } catch (error) {
        console.error("Error fetching brands:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBrands();
  }, []);

  // Update form data when data prop changes (when coming back from previous steps)
  useEffect(() => {
    if (data) {
      // If we have a brandId but no brandName, try to find the brand name from the brands array
      // let brandName = data.brandName || '';
      // if (data.brandId && !brandName && brands.length > 0) {
      //   const brand = brands.find(b => b._id === data.brandId);
      //   if (brand) {
      //     brandName = brand.brandName;
      //   }
      //   }
      
      setFormData({
        name: data.name || '',
        description: data.description || '',
        brandId: data.brandId || '',
        brandName: data.brandName || '',
        campaignType: data.campaignType || '',
        startDate: data.startDate || '',
        endDate: data.endDate || ''
      });
    }
  }, [data, brands]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate required fields
    if (!formData.name || !formData.brandId || !formData.campaignType || !formData.startDate || !formData.endDate) {
      toast.error("Please fill in all required fields in General section");
      return;
    }

    // Validate that start date is before end date
    if (new Date(formData.startDate) >= new Date(formData.endDate)) {
      toast.error("Start date must be before end date");
      return;
    }

    // Create the general data object with all required fields
    const generalData = {
      name: formData.name.trim(),
      brandId: formData.brandId,
      brandName: formData.brandName,
      campaignType: formData.campaignType,
      description: formData.description || '',
      startDate: formData.startDate,
      endDate: formData.endDate
    };


    // Dispatch to Redux first
    dispatch(setGeneralData(generalData));

    // Then call onNext with the data
    onNext(generalData);
  };

  return (
    <div className="w-full bg-white shadow p-4 md:p-6 rounded-md">
      <h3 className="text-lg font-semibold mb-4">General</h3>
      <form className="space-y-6" onSubmit={handleSubmit}>
        {/* Brand Selection */}
        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700">
            Select Brand <span className="text-red-500">*</span>
          </label>
          {loading ? (
            <div className="mt-1 animate-pulse bg-gray-200 h-10 rounded-md"></div>
          ) : (

            <BrandDropdown
              brands={brands}
              value={formData.brandId}
              onChange={(brand) =>
                setFormData((prev) => ({
                  ...prev,
                  brandId: brand._id,
                  brandName: brand.brandName,
                }))
              }
            />

            // <>
            //   <select
            //     value={formData.brandId}
            //     onChange={(e) => {
            //       const value = e.target.value;
            //       const selectedBrand = brands.find(brand => brand._id === value);
            //       setFormData(prev => ({
            //         ...prev,
            //         brandId: value,
            //         brandName: selectedBrand ? selectedBrand.brandName : ''
            //       }));
            //     }}

            //     className="w-full border border-orange-300 rounded-md p-2 mt-1 focus:border-orange-500 focus:ring-orange-500"
            //     required
            //   >
            //     <option value="">Select a brand</option>
            //     {brands.map((brand) => (
            //       <option key={brand._id} value={brand._id}>
            //         {brand.brandName}
            //       </option>
            //     ))}
            //   </select>
            //   {brands.length === 0 && (
            //     <p className="mt-1 text-sm text-red-500">
            //       No active brands found. Please create a brand first.
            //     </p>
            //   )}
            // </>
          )}
        </div>

        {/* Name Input */}
        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700">
            Campaign Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            className="w-full border border-orange-300 rounded-md p-2 mt-1 focus:border-orange-500 focus:ring-orange-500"
            placeholder="Enter campaign name"
            required
          />
        </div>

        {/* Campaign Type Dropdown */}
        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700">
            Campaign Type <span className="text-red-500">*</span>
          </label>
          <select
            name="campaignType"
            value={formData.campaignType}
            onChange={handleInputChange}
            required
            className="w-full border border-orange-300 rounded-md p-2 mt-1 focus:border-orange-500 focus:ring-orange-500"
          >
            <option value="">Select a type</option>
            <option value="Advertising">Advertising</option>
            <option value="Affiliate">Affiliate</option>
            <option value="Hybrid">Hybrid</option>
          </select>
        </div>

        {/* Campaign Dates - Responsive Layout */}
        <div className="w-full">
          {/* Desktop/Tablet Layout - Dates side by side */}
          <div className="hidden md:grid md:grid-cols-2 md:gap-4">
            {/* Campaign Start Date */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Campaign Start Date <span className="text-red-500">*</span>
              </label>
              <DatePicker
                selected={formData.startDate ? new Date(formData.startDate) : null}
                onChange={(date) => setFormData(prev => ({ ...prev, startDate: date.toISOString() }))}
                minDate={today}
                maxDate={sixMonthsLater}
                placeholderText="Select start date"
                className="w-full border border-orange-300 rounded-md p-2 mt-1 focus:border-orange-500 focus:ring-orange-500"
                required
                dateFormat="yyyy-MM-dd"
              />
            </div>

            {/* Campaign End Date */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Campaign End Date <span className="text-red-500">*</span>
              </label>
              <DatePicker
                selected={formData.endDate ? new Date(formData.endDate) : null}
                onChange={(date) => setFormData(prev => ({ ...prev, endDate: date.toISOString() }))}
                minDate={formData.startDate ? new Date(formData.startDate) : today}
                maxDate={sixMonthsLater}
                placeholderText="Select end date"
                className="w-full border border-orange-300 rounded-md p-2 mt-1 focus:border-orange-500 focus:ring-orange-500"
                required
                dateFormat="yyyy-MM-dd"
              />
            </div>
          </div>

          {/* Mobile Layout - Dates stacked vertically */}
          <div className="md:hidden space-y-4">
            {/* Campaign Start Date */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Campaign Start Date <span className="text-red-500">*</span>
              </label>
              <DatePicker
                selected={formData.startDate ? new Date(formData.startDate) : null}
                onChange={(date) => setFormData(prev => ({ ...prev, startDate: date.toISOString() }))}
                minDate={today}
                maxDate={sixMonthsLater}
                placeholderText="Select start date"
                className="w-full border border-orange-300 rounded-md p-2 mt-1 focus:border-orange-500 focus:ring-orange-500"
                required
                dateFormat="yyyy-MM-dd"
              />
            </div>

            {/* Campaign End Date */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Campaign End Date <span className="text-red-500">*</span>
              </label>
              <DatePicker
                selected={formData.endDate ? new Date(formData.endDate) : null}
                onChange={(date) => setFormData(prev => ({ ...prev, endDate: date.toISOString() }))}
                minDate={formData.startDate ? new Date(formData.startDate) : today}
                maxDate={sixMonthsLater}
                placeholderText="Select end date"
                className="w-full border border-orange-300 rounded-md p-2 mt-1 focus:border-orange-500 focus:ring-orange-500"
                required
                dateFormat="yyyy-MM-dd"
              />
            </div>
          </div>
        </div>

        {/* Description Section */}
        <div className="w-full">
          <div className="flex mb-4 space-x-4 overflow-x-auto">
            <button
              type="button"
              className="text-blue-600 border-b-2 border-blue-600 pb-2 px-2 whitespace-nowrap focus:outline-none"
            >
              Description
            </button>
          </div>

          <textarea
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            rows="4"
            className="w-full border border-gray-300 rounded-md p-2 focus:border-orange-500 focus:ring-orange-500"
            placeholder="Enter description here..."
          ></textarea>
        </div>

        {/* Submit Button */}
        <div className="text-right">
          <button
            type="submit"
            aria-label="Go to next step"
            disabled={!formData.brandId || brands.length === 0}
            className={`px-4 py-2 rounded-md transition duration-300 ${!formData.brandId || brands.length === 0
                ? 'bg-gray-300 cursor-not-allowed'
                : 'bg-orange-500 text-white hover:bg-orange-600'
              }`}
          >
            Next
          </button>
        </div>
      </form>
    </div>
  );
};

export default General; 